export default "__VITE_ASSET__pi$haFs___"